export default __webpack_public_path__ + "static/media/MeieScript-Regular.a1f3a249.ttf";